export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000"
export const DATE_FORMAT_DISPLAY = "D.MMM YY'"
export const DATETIME_FORMAT_DISPLAY = "D.M.YY HH:mm"
export const TIME_FORMAT_DISPLAY = "HH:mm"
export const DATETIME_FORMAT = "YYYY-MM-DDTHH:mm"
export const DATETIME_FOR_LOCAL_INPUT = "YYYY-MM-DDTHH:mm"
export const DATE_FORMAT = "YYYY-MM-DD"
export const MAX_MINUTES_TIME_ENTRY = 1380
export const COLORS = [
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#d62728",
  "#9467bd",
  "#8c564b",
  "#e377c2",
  "#17becf",
  "#bcbd22",
  "#7f7f7f",
  "#aec7e8",
  "#ffbb78",
  "#98df8a",
  "#ff9896",
  "#c5b0d5",
  "#c49c94",
  "#f7b6d2",
  "#9edae5",
  "#dbdb8d",
  "#c7c7c7",
]

export const CALL_OUTCOMES = [
  { value: "Tbd", text: "Razlog bo določen kasneje", hint: "samo shrani klic" },
  { value: "WrongNumber", text: "Napačna številka", hint: "" },
  { value: "Users", text: "Vklop in izklop porabnikov", hint: "obvezen objekt, izberi naprave" },
  { value: "Other", text: "Drugo", hint: "ustvari interni nalog iz opombe" },
  { value: "Complaint", text: "Reklamacija dela", hint: "interni nalog za Uroša - obvezni stranka, objekt in SDN" },
  { value: "Grievance", text: "Pritožba", hint: "ustvari opravilo za Uroša (stranka/objekt nista obvezna)" },
  { value: "Attention", text: "Prijava nove napake", hint: "nov SDN za stranko in objekt" },
  // UI-only - CallEdit shows one "Alarm" choice whose two buttons record AlertSolved or Alert
  { value: "Alarm", text: "Alarm", hint: "preverba stanja ali obisk", uiOnly: true },
  // the two stored alarm outcomes - kept for displaying recorded calls, not offered as separate choices
  {
    value: "AlertSolved",
    text: "Alarm: preverba stanja",
    hint: "urejeno preko daljinskega nadzora",
    alarm: true,
  },
  { value: "Alert", text: "Alarm: obisk je potreben", hint: "nov SDN za stranko in objekt", alarm: true },
  { value: "ExistingSdn", text: "Obstoječi SDN", hint: "poveži SDN na desni" },
]
